export default __webpack_public_path__ + "static/media/my-bookings.58b97d07.svg";